// extracted by mini-css-extract-plugin
module.exports = {"layout":"LandingLayout_layout__kV7pg","main":"LandingLayout_main__gGW1q"};